import type { Resource } from '../../';
export const country_countries_ZA: Resource = {"default":"South Africa"};
